module.exports = __webpack_public_path__ + "static/media/lb-logo-2048.8feb9a63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/lb-logo-2048.svg
// module id = 888
// module chunks = 0